import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'First Name is a required field.'}
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Last Name is a required field.'}
      ]
    },
    CellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.'},
        { type: 'required', message: 'Mobile Phone is a required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Email is a required field.'}
      ]
    },
    AccountExtra2: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    StartTime: {
      validations: []
    },
    Theme: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Notes: {
      validations: []
    },
    AccountExtra1: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'First Name',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'First Name',
            mapping: 'FirstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Last Name',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Last Name',
            mapping: 'LastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Mobile Phone',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Mobile Phone',
            mapping: 'CellNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Email',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Email',
            mapping: 'Email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Receive Email Promotions',
            options: [
              {label: 'Yes', value: 'Yes'},
              {label: 'No', value: 'No'}
            ],
            mapping: 'headerLabel',
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Receive Email Promotions',
            options: [
              {label: 'Yes', value: 'Yes'},
              {label: 'No', value: 'No'}
            ],
            mapping: 'AccountExtra2',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Requests',
            mapping: 'headerLabel',
            customClasses: ['header']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Event Date',
            mapping: 'headerLabel',
          },
          {
            type: 'date-picker',
            size: 'Large',
            label: 'Event Date',
            mapping: 'EventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Start Time',
            options: [
              { label: '6:00 AM', value: '06:00:00' },
              { label: '6:30 AM', value: '06:30:00' },
              { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
              { label: '2:30 AM', value: '02:30:00' },
              { label: '3:00 AM', value: '03:00:00' },
              { label: '3:30 AM', value: '03:30:00' },
              { label: '4:00 AM', value: '04:00:00' },
              { label: '4:30 AM', value: '04:30:00' },
              { label: '5:00 AM', value: '05:00:00' },
              { label: '5:30 AM', value: '05:30:00' }
            ],
            mapping: 'headerLabel',
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Start Time',
            options: [
              { label: '6:00 AM', value: '06:00:00' },
              { label: '6:30 AM', value: '06:30:00' },
              { label: '7:00 AM', value: '07:00:00' },
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
              { label: '2:30 AM', value: '02:30:00' },
              { label: '3:00 AM', value: '03:00:00' },
              { label: '3:30 AM', value: '03:30:00' },
              { label: '4:00 AM', value: '04:00:00' },
              { label: '4:30 AM', value: '04:30:00' },
              { label: '5:00 AM', value: '05:00:00' },
              { label: '5:30 AM', value: '05:30:00' }
            ],
            mapping: 'StartTime',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Function Type',
            options: [
              { label: 'Adult Party' , value: 'Adult Party'},
              { label: 'Bachelor / Bachelorette', value: 'Bachelor / Bachelorette'},
              { label: 'Bachelor / Bachelorette Parties', value: 'Bachelor / Bachelorette Parties'},
              { label: 'Bar/Bat Mitzvah', value: 'Bar/Bat Mitzvah'},
              { label: 'Bar Mitzvah / Bat Mitzvah', value: 'Bar Mitzvah / Bat Mitzvah'},
              { label: 'Billiards', value: 'Billiards'},
              { label: 'Birthday Party', value: 'Birthday Party'},
              { label: 'Bowling', value: 'Bowling'},
              { label: 'Buffet', value: 'Buffet'},
              { label: 'Charity', value: 'Charity'},
              { label: 'Dinner', value: 'Dinner'},
              { label: 'Family-Style', value: 'Family-Style'},
              { label: 'Happy Hour', value: 'Happy Hour'},
              { label: 'Holiday Party', value: 'Holiday Party'},
              { label: 'Lane Reservations', value: 'Lane Reservations'},
              { label: 'Lunch', value: 'Lunch'},
              { label: 'Lunch & Bowling', value: 'Lunch & Bowling'},
              { label: 'Movie Function', value: 'Movie Function'},
              { label: 'Networking', value: 'Networking'},
              { label: 'Open Bar', value: 'Open Bar'},
              { label: 'Platters', value: 'Platters'},
              { label: 'Priority Bowling', value: 'Priority Bowling'},
              { label: 'Private party', value: 'Private party'},
              { label: 'Promotion', value: 'Promotion'},
              { label: 'Rehearsal', value: 'Rehearsal'},
              { label: 'Shower', value: 'Shower'},
              { label: 'Shuffle Board', value: 'Shuffle Board'},
              { label: 'Table reservation', value: 'Table reservation'},
              { label: 'Team Building / Office Party', value: 'Team Building / Office Party'},
              { label: 'Teenage Party', value: 'Teenage Party'},
              { label: 'Tournament', value: 'Tournament'},
              { label: 'Valentine Package', value: 'Valentine Package'},
              { label: 'Venue', value: 'Venue'},
              { label: 'Walk-in', value: 'Walk-in'},
              { label: 'Wedding – Rehearsal Dinner', value: 'Wedding – Rehearsal Dinner'}
            ],
            mapping: 'headerLabel',
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            label: 'Function Type',
            options: [
              { label: 'Adult Party' , value: 'Adult Party'},
              { label: 'Bachelor / Bachelorette', value: 'Bachelor / Bachelorette'},
              { label: 'Bachelor / Bachelorette Parties', value: 'Bachelor / Bachelorette Parties'},
              { label: 'Bar/Bat Mitzvah', value: 'Bar/Bat Mitzvah'},
              { label: 'Bar Mitzvah / Bat Mitzvah', value: 'Bar Mitzvah / Bat Mitzvah'},
              { label: 'Billiards', value: 'Billiards'},
              { label: 'Birthday Party', value: 'Birthday Party'},
              { label: 'Bowling', value: 'Bowling'},
              { label: 'Buffet', value: 'Buffet'},
              { label: 'Charity', value: 'Charity'},
              { label: 'Dinner', value: 'Dinner'},
              { label: 'Family-Style', value: 'Family-Style'},
              { label: 'Happy Hour', value: 'Happy Hour'},
              { label: 'Holiday Party', value: 'Holiday Party'},
              { label: 'Lane Reservations', value: 'Lane Reservations'},
              { label: 'Lunch', value: 'Lunch'},
              { label: 'Lunch & Bowling', value: 'Lunch & Bowling'},
              { label: 'Movie Function', value: 'Movie Function'},
              { label: 'Networking', value: 'Networking'},
              { label: 'Open Bar', value: 'Open Bar'},
              { label: 'Platters', value: 'Platters'},
              { label: 'Priority Bowling', value: 'Priority Bowling'},
              { label: 'Private party', value: 'Private party'},
              { label: 'Promotion', value: 'Promotion'},
              { label: 'Rehearsal', value: 'Rehearsal'},
              { label: 'Shower', value: 'Shower'},
              { label: 'Shuffle Board', value: 'Shuffle Board'},
              { label: 'Table reservation', value: 'Table reservation'},
              { label: 'Team Building / Office Party', value: 'Team Building / Office Party'},
              { label: 'Teenage Party', value: 'Teenage Party'},
              { label: 'Tournament', value: 'Tournament'},
              { label: 'Valentine Package', value: 'Valentine Package'},
              { label: 'Venue', value: 'Venue'},
              { label: 'Walk-in', value: 'Walk-in'},
              { label: 'Wedding – Rehearsal Dinner', value: 'Wedding – Rehearsal Dinner'}
            ],
            mapping: 'Theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Company Name',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Company Name',
            mapping: 'ClientName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Estimated Attendance',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Estimated Attendance',
            mapping: 'PlannedGuestCount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Budget',
            mapping: 'headerLabel',
          },
          {
            type: 'text',
            size: 'Large',
            label: 'Budget',
            mapping: 'AccountExtra1',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Description',
            mapping: 'headerLabel',
          },
          {
            type: 'text-area',
            size: 'Large',
            label: 'Description',
            mapping: 'Notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Paragon Village Splitsville Contact Form',
    formId: '473',
    clientKey: 'DF62B67F-4939-4957-8CB3-2A308AE0646A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/paragonvillagesplitsville/form_structure.js